import { memo } from "react";
import PageContent from "./PageContent";
import PageHeader from "./PageHeader";
import PageLayout from "./PageLayout";

interface PageProps {
  header: React.ReactNode;
  children: React.ReactNode;
  slotProps?: {
    pageContent?: React.ComponentProps<typeof PageContent>;
  };
}

/**
 * @description A layout component for pages that includes a header and content area.
 * The header is displayed at the top and wraps the layout's header component.
 * The content area is displayed below the header and wraps the layout's content component.
 */
function Page(props: PageProps) {
  const { header, children, slotProps } = props;
  return (
    <PageLayout>
      <PageHeader>{header}</PageHeader>
      <PageContent {...slotProps?.pageContent}>{children}</PageContent>
    </PageLayout>
  );
}

export default memo(Page);
